import Dashboard from '@pages/Dashboard';
import Profile from '@pages/profile/Profile';
import Account from '@pages/account/Account';
import AccountAdd from '@pages/account/AccountAdd';
import AccountEdit from '@pages/account/AccountEdit';
import EmailConfig from '@pages/emailConfig/EmailConfig';
import EmailConfigAdd from '@pages/emailConfig/EmailConfigAdd';
import EmailConfigEdit from '@pages/emailConfig/EmailConfigEdit';
import LoginHistory from '@app/pages/report/countLogin/LoginHistory';
import StatisticLoginHistory from '@app/pages/report/countLogin/StatisticLoginHistory';
import Log from '@pages/log/Log';
import ApiRoleMapping from '@app/pages/apiRoleMapping/ApiRoleMapping';
import ApiRoleMappingAdd from '@app/pages/apiRoleMapping/ApiRoleMappingAdd';
import ApiRoleMappingEdit from '@app/pages/apiRoleMapping/ApiRoleMappingEdit';
import PositionList from '@pages/position/PositionList';
import PositionAdd from '@pages/position/PositionAdd';
import PositionEdit from '@pages/position/PositionEdit';

import { URI_INTERNAL } from './utils/pathLocations';
import OpeniddictApplication from '@app/pages/openiddictApplication/OpeniddictApplication';
import OpeniddictApplicationAdd from '@app/pages/openiddictApplication/OpeniddictApplicationAdd';
import OpeniddictApplicationEdit from '@app/pages/openiddictApplication/OpeniddictApplicationEdit';
import RoleAccount from '@app/pages/roleAccount/RoleAccount';
import RoleAccountAdd from '@app/pages/roleAccount/RoleAccountAdd';
import RoleAccountEdit from '@app/pages/roleAccount/RoleAccountEdit';
import KySo from '@app/pages/kySo/KySo';
import ProjectList from '@app/pages/project/ProjectList';
import ProjectAdd from '@app/pages/project/ProjectAdd';
import ProjectEdit from '@app/pages/project/ProjectEdit';
import AssignedJobList from '@app/pages/assigned_job/AssignedJobList';
import AssignedJobAdd from '@app/pages/assigned_job/AssignedJobAdd';
import AssignedJobEdit from '@app/pages/assigned_job/AssignedJobEdit';
import PersonalKanban from '@app/pages/project/PersonalKanban';
import MyTasks from '@app/pages/MyTasks';
import JobGroupList from '@app/pages/jobGroup/JobGroupList';
import JobGroupAdd from '@app/pages/jobGroup/JobGroupAdd';
import JobGroupEdit from '@app/pages/jobGroup/JobGroupEdit';

// Annual Job
import AnnualJobCategoryList from '@app/pages/annualJobCategory/AnnualJobCategoryList';
import AnnualJobCategoryAdd from '@app/pages/annualJobCategory/AnnualJobCategoryAdd';
import AnnualJobCategoryEdit from '@app/pages/annualJobCategory/AnnualJobCategoryEdit';
import AnnualJobRegistrationList from '@app/pages/annual_job/AnnualJobRegistrationList';
import AnnualJobRegistrationForm from '@app/pages/annual_job/AnnualJobRegistrationForm';
import AnnualJobApproval from '@app/pages/annual_job/AnnualJobApproval';
import AnnualJobKanban from '@app/pages/annual_job/AnnualJobKanban';
import MemberTracking from '@app/pages/annual_job/MemberTracking';
import WorkResultList from '@app/pages/workResult/WorkResultList';
import ReportExport from '@app/pages/reportExport/ReportExport';

const rawRoutes = [
  {
    path: URI_INTERNAL.WORK_RESULT_PATH,
    exact: true,
    component: WorkResultList,
    isPublic: false,
    controller: 'WorkResult',
    action: '',
    label: 'Kết quả công việc',
    menu: true,
  },
  {
    path: URI_INTERNAL.REPORT_EXPORT_PATH,
    exact: true,
    component: ReportExport,
    isPublic: false,
    controller: 'WorkResult',
    action: '',
    label: 'Xuất báo cáo',
    menu: true,
  },
  // dashboard
  {
    path: "/", // bạn có thể thêm HOME_PATH = '/'
    exact: true,
    component: Dashboard,
    isPublic: false,
    controller: 'Dashboard',
    action: '',
    label: "Tổng quan",
    menu: true,
    isPublic: false,
  },
  // Project
  {
    path: URI_INTERNAL.PROJECT_PATH,
    exact: true,
    component: ProjectList,
    isPublic: false,
    controller: 'Project',
    action: '',
    label: "Công việc đột xuất",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PROJECT_PATH_ADD,
    exact: true,
    component: ProjectAdd,
    isPublic: false,
    controller: 'Project',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PROJECT_PATH_EDIT,
    exact: true,
    component: ProjectEdit,
    isPublic: false,
    controller: 'Project',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  // Assigned Job
  {
    path: URI_INTERNAL.ASSIGNED_JOB_PATH,
    exact: true,
    component: AssignedJobList,
    isPublic: false,
    controller: 'AssignedJob',
    action: '',
    label: "Giao công việc",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ASSIGNED_JOB_PATH_ADD,
    exact: true,
    component: AssignedJobAdd,
    isPublic: false,
    controller: 'AssignedJob',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ASSIGNED_JOB_PATH_EDIT,
    exact: true,
    component: AssignedJobEdit,
    isPublic: false,
    controller: 'AssignedJob',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: '/project/personal-kanban',
    exact: true,
    component: MyTasks,
    isPublic: false,
    controller: 'PersonalTask',
    action: '',
    label: "Nhiệm vụ của tôi",
    menu: true,
    isPublic: false,
  },
  // profile
  {
    path: "/profile",
    exact: true,
    component: Profile,
    isPublic: false,
    // controller: 'Profile',
    // action:     'View',
    // label:      'Profile',
    controller: '',
    action: '',
    label: "Thông tin cá nhân",
    menu: false,
    isPublic: false,
  },
  // account
  {
    path: URI_INTERNAL.ACCOUNT_PATH,
    exact: true,
    component: Account,
    isPublic: false,
    controller: 'Account',
    // controller: '',
    action: '',
    label: "Tài khoản",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNT_PATH_ADD,
    exact: true,
    component: AccountAdd,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNT_PATH_EDIT,
    exact: true,
    component: AccountEdit,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  // Position
  {
    path: URI_INTERNAL.POSITION_PATH,
    exact: true,
    component: PositionList,
    isPublic: false,
    controller: 'Position',
    action: '',
    label: "Danh mục vị trí",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.POSITION_PATH_ADD,
    exact: true,
    component: PositionAdd,
    isPublic: false,
    controller: 'Position',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.POSITION_PATH_EDIT,
    exact: true,
    component: PositionEdit,
    isPublic: false,
    controller: 'Position',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  //role
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_PATH,
    exact: true,
    component: RoleAccount,
    isPublic: false,
    controller: 'Role',
    // controller: '',
    action: '',
    label: "Quyền",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_CREATE_PATH,
    exact: true,
    component: RoleAccountAdd,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_EDIT_PATH,
    exact: true,
    component: RoleAccountEdit,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  // email config
  {
    path: URI_INTERNAL.EMAILCONFIG_PATH,
    exact: true,
    component: EmailConfig,
    isPublic: false,
    controller: 'EmailConfig',
    // controller: '',
    action: '',
    label: "Email gửi thông báo",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.EMAILCONFIG_CREATE_PATH,
    exact: true,
    component: EmailConfigAdd,
    isPublic: false,
    // controller: 'EmailConfig',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.EMAILCONFIG_EDIT_PATH,
    exact: true,
    component: EmailConfigEdit,
    isPublic: false,
    // controller: 'EmailConfig',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  // job group
  {
    path: URI_INTERNAL.JOBGROUP_PATH,
    exact: true,
    component: JobGroupList,
    isPublic: false,
    controller: 'JobGroup',
    action: '',
    label: "Nhóm công việc",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.JOBGROUP_PATH_ADD,
    exact: true,
    component: JobGroupAdd,
    isPublic: false,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.JOBGROUP_PATH_EDIT,
    exact: true,
    component: JobGroupEdit,
    isPublic: false,
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  // reports
  {
    path: URI_INTERNAL.LOGIN_HISTORY_PATH,
    exact: true,
    component: LoginHistory,
    isPublic: false,
    controller: 'LoginHistory',
    // controller: '',
    action: '',
    label: "Lịch sử đăng nhập",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.STATISTIC_HISTORY_PATH,
    exact: true,
    component: StatisticLoginHistory,
    isPublic: false,
    // controller: 'Report',
    controller: '',
    action: '',
    label: "Thống kê lịch sử đăng nhập",
    menu: true,
    isPublic: false,
  },
  // api-role-mapping
  {
    path: URI_INTERNAL.APIROLEMAPPING_PATH,
    exact: true,
    component: ApiRoleMapping,
    isPublic: false,
    controller: 'ApiRoleMapping',
    // controller: '',
    action: '',
    label: "Phân quyền API",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.APIROLEMAPPING_CREATE_PATH,
    exact: true,
    component: ApiRoleMappingAdd,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Them',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.APIROLEMAPPING_EDIT_PATH,
    exact: true,
    component: ApiRoleMappingEdit,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Sua',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_PATH,
    exact: true,
    component: OpeniddictApplication,
    isPublic: false,
    controller: 'OpeniddictApplication',
    // controller: '',
    action: '',
    label: "Ứng dụng đăng ký",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_CREATE_PATH,
    exact: true,
    component: OpeniddictApplicationAdd,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Them',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_EDIT_PATH,
    exact: true,
    component: OpeniddictApplicationEdit,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Sua',
    label: "",
    menu: false,
    isPublic: false,
  },
  // log
  {
    path: URI_INTERNAL.LOG_PATH,
    exact: true,
    component: Log,
    isPublic: false,
    controller: 'Log',
    // controller: '',
    action: '',
    label: "Xem log",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.KYSO_PATH,
    exact: true,
    component: KySo,
    isPublic: false,
    controller: 'KySo',
    // controller: '',
    action: '',
    label: "Ký số",
    menu: true,
    isPublic: false,
  },
  // Annual Job Routes
  {
    path: URI_INTERNAL.ANNUAL_JOB_CATEGORY_PATH,
    exact: true,
    component: AnnualJobCategoryList,
    isPublic: false,
    controller: 'AnnualJob',
    action: '',
    label: "Danh mục công việc",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ANNUAL_JOB_CATEGORY_PATH_ADD,
    exact: true,
    component: AnnualJobCategoryAdd,
    isPublic: false,
    controller: 'AnnualJob',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ANNUAL_JOB_CATEGORY_PATH_EDIT,
    exact: true,
    component: AnnualJobCategoryEdit,
    isPublic: false,
    controller: 'AnnualJob',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: '/annual-job/registration',
    exact: true,
    component: AnnualJobRegistrationList,
    isPublic: false,
    controller: 'AnnualJobRegistration',
    action: '',
    label: "Phiếu đăng ký",
    menu: true,
    isPublic: false,
  },
  {
    path: '/annual-job/registration/:id',
    exact: true,
    component: AnnualJobRegistrationForm,
    isPublic: false,
    controller: 'AnnualJobRegistration',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: '/annual-job/approval',
    exact: true,
    component: AnnualJobApproval,
    isPublic: false,
    controller: 'AnnualJobApproval',
    action: '',
    label: "Duyệt phiếu",
    menu: true,
    isPublic: false,
  },
  {
    path: '/annual-job/kanban',
    exact: true,
    component: AnnualJobKanban,
    isPublic: false,
    controller: 'AnnualJobKanban',
    action: '',
    label: "Công việc thường niên",
    menu: false,
    isPublic: false,
  },
  {
    path: '/annual-job/tracking',
    exact: true,
    component: MemberTracking,
    isPublic: false,
    controller: 'MemberTracking',
    action: '',
    label: "Theo dõi tiến độ",
    menu: true,
    isPublic: false,
  },
];

// function withController(routes) {
//   return routes.map(r => {
//     const name = r.component.displayName || r.component.name || '';
//     return {
//       ...r,
//       controller: r.controller ? r.controller : name,
//       // nếu chưa có label thì lấy tên component
//       label: r.label || name,
//     };
//   });
// }

function withController(routes) {
  return routes.map(r => ({
    ...r,
    // controller: r.controller,
    label: r.label || r.controller,
  }));
}

export const appRoutes = withController(rawRoutes);

export const menuGroups = [
  {
    title: "Quản trị",
    icon: "fas fa-shield-alt",
    children: [
      appRoutes.find(r => r.menu && r.controller === "Dashboard"),
      appRoutes.find(r => r.menu && r.controller === "AnnualJobApproval"),
      appRoutes.find(r => r.menu && r.controller === "AssignedJob"),
      appRoutes.find(r => r.menu && r.path === URI_INTERNAL.WORK_RESULT_PATH),
      appRoutes.find(r => r.menu && r.path === URI_INTERNAL.REPORT_EXPORT_PATH)
    ].filter(Boolean)
  },
  {
    title: "Công việc cá nhân",
    icon: "fas fa-user-clock",
    children: [
      "AnnualJobRegistration",
      "Project",
      "PersonalTask",
      "MemberTracking"
    ].map(ctrl => appRoutes.find(r => r.menu && r.controller === ctrl)).filter(Boolean)
  },
  {
    title: "Danh mục",
    icon: "fas fa-tags",
    children: appRoutes.filter(r =>
      r.menu && [
        "JobGroup",
        "AnnualJob",
        "Position"
      ].includes(r.controller)
    )
  },
  {
    title: "Hệ thống",
    icon: "fas fa-cog",
    // Lấy tất cả route menu thuộc nhóm Hệ thống
    children: appRoutes.filter(r =>
      r.menu && [
        "Account",
        "Role",
        "EmailConfig",
        "ApiRoleMapping",
        "OpeniddictApplication",
        "Log",
        "KySo"
      ].includes(r.controller)
    )
  }
];
